import { useState, useEffect } from 'react';

const SupportMyTickets = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate loading
    setTimeout(() => setLoading(false), 1000);
  }, []);

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-green-600"></div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container mx-auto px-4 py-6 max-w-7xl">
        {/* Page Header */}
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">My Support Tickets</h1>
          <p className="text-gray-600">View and manage your assigned tickets</p>
        </div>

        {/* Content Placeholder */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-8">
          <div className="text-center">
            <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
              <i className="fas fa-user-check text-green-600 text-2xl"></i>
            </div>
            <h3 className="text-lg font-semibold text-gray-900 mb-2">My Support Tickets</h3>
            <p className="text-gray-600 mb-4">
              This page will contain personal ticket management functionality including:
            </p>
            <ul className="text-left text-gray-600 space-y-2 max-w-md mx-auto">
              <li>• View tickets assigned to you</li>
              <li>• Update ticket status and resolution</li>
              <li>• Add comments and notes</li>
              <li>• Track your performance metrics</li>
              <li>• Personal workload management</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupportMyTickets;